import React, { useEffect, useState } from "react";
import { createTodo, getAllTodo } from "../../Services/MasterService";
import { toast } from "react-toastify";

const AddTodo = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        title: null,
        parent_id: null,
        is_default: null,
        description: null,
        type: null,
        cta_name: null,
        id: null
    });
    const [loader, setLoader] = useState(false);
    const [todo, setTodo] = useState([]);

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await createTodo(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    const getAllTodoCall = async () => {
        let { ok, data } = await getAllTodo({});
        if (ok) {
            setTodo(data?.records);
        }
    };

    useEffect(() => {
        getAllTodoCall();
        if (data?.data) {
            const { title, parent_id, is_default, description, type, cta_name, id } = data?.data;
            setReqData({ title, parent_id, is_default, description, type, cta_name, id })
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add Todo" : "Edit Todo"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Title</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Title"
                                                required
                                                value={reqData?.title}
                                                onChange={(e) => handleChange("title", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Type</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Type"
                                                required
                                                value={reqData?.type}
                                                onChange={(e) => handleChange("type", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>CTA Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="CTA Name"
                                                required
                                                value={reqData?.cta_name}
                                                onChange={(e) => handleChange("cta_name", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Default</label>
                                            <select required value={reqData?.is_default} onChange={(e) => handleChange("is_default", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Default</option>
                                                <option value={true}>True</option>
                                                <option value={false}>False</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Parent</label>
                                            <select required value={reqData?.parent_id} onChange={(e) => handleChange("parent_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Parent</option>
                                                {todo?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.title}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Description</label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                placeholder="Description"
                                                required
                                                value={reqData?.description}
                                                onChange={(e) => handleChange("description", e?.target?.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddTodo;